import React from 'react'

const LifeInsuranceForm = () => {
    return (
        <form className='text-dark'>
            {/* x---------------------------------x Personal Details x---------------------------------x */}
            <div>
                <div className="pb-4 mb-4">
                    <h4 className="text-xl font-semibold">Personal Details</h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="firstName" className="block mb-1 text-sm font-medium">First Name</label>
                        <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" id="firstName"
                            placeholder='Enter Your Firstname'
                            required />
                    </div>
                    <div>
                        <label htmlFor="lastName" className="block mb-1 text-sm font-medium">Last Name</label>
                        <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" id="lastName"
                            placeholder='Enter Your Lastname'
                            required />
                    </div>
                    <div>
                        <label htmlFor="dob" className="block mb-1 text-sm font-medium">Date of Birth</label>
                        <input type="date" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" id="dob" required />
                    </div>
                    <div>
                        <label htmlFor="gender" className="block mb-1 text-sm font-medium">Gender</label>
                        <select className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" id="gender" required defaultValue={'DEFAULT'}>
                            <option value="DEFAULT" disabled>Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                        </select>
                    </div>
                    <div className="md:col-span-2">
                        <label htmlFor="address" className="block mb-1 text-sm font-medium">Address</label>
                        <textarea placeholder="Enter your address" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" id="address" rows="3" required autoComplete='off'></textarea>
                    </div>
                </div>
            </div>

            {/* x---------------------------------x Insurance Details x---------------------------------x */}
            <div className='sm:mt-5 mt-3'>
                <div className="pb-4 mb-4">
                    <h4 className="text-xl font-semibold">Insurance Details</h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="policyType" className="block mb-1 text-sm font-medium">Policy Type</label>
                        <select className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" id="policyType" required defaultValue={'DEFAULT'}>
                            <option value="DEFAULT" disabled>Select Policy Type</option>
                            <option value="term">Term Life Insurance</option>
                            <option value="whole">Whole Life Insurance</option>
                            <option value="universal">Universal Life Insurance</option>
                        </select>
                    </div>
                    <div>
                        <label htmlFor="coverageAmount" className="block mb-1 text-sm font-medium">Coverage Amount</label>
                        <input type="number" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" id="coverageAmount" required />
                    </div>
                    <div>
                        <label htmlFor="beneficiaryName" className="block mb-1 text-sm font-medium">Beneficiary Name</label>
                        <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" id="beneficiaryName" required />
                    </div>
                    <div>
                        <label htmlFor="beneficiaryRelation" className="block mb-1 text-sm font-medium">Relationship to Beneficiary</label>
                        <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" id="beneficiaryRelation" required />
                    </div>
                </div>
            </div>

            {/* x---------------------------------x Contact Infrmation x---------------------------------x */}
            <div className='sm:mt-5 mt-3'>
                <div className="pb-4 mb-4" >
                    <h4 className="text-xl font-semibold">Contact Information</h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="email" className="block mb-1 text-sm font-medium">Email Address</label>
                        <input type="email" placeholder="Enter your Email" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" id="email" required autoComplete='off' />
                    </div>
                    <div>
                        <label htmlFor="phone" className="block mb-1 text-sm font-medium">Phone Number</label>
                        <input type="tel" placeholder="+00 00000 00000" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" id="phone" required autoComplete='off' />
                    </div>
                </div>
            </div>

            {/* x---------------------------------x Submit Button x---------------------------------x */}
            <div className="text-start mt-6">
                <button type="submit" className="bg-primary-900 text-white hover:bg-primary-800 rounded-lg py-2 px-4">Submit Application</button>
            </div>
        </form >

    )
}

export default LifeInsuranceForm